module.exports = __webpack_public_path__ + "static/media/playlists.4c9270c7.svg";